export const navigationActions = ({navigate, updateData}) => {
    const navGen = (path) => () => navigate(path)
    const navigateDevk = () => {
        window.open(
            "https://devk-demo.teckpro.de/motivatoren/index.html",
            "_blank",
            "noopener,noreferrer"
        )
    }
    const navigateAction = (link) => {
        if (link.startsWith("http")) {
            window.open(link, "_blank")
        } else {
            navigate(link)
        }
    }
    const navigateAngebot = ({value}) => {
        if (value === "ANLAESSE") {
            navigate("/anlaesse")
        } else if (value === "PRODUKTE") {
            window.open("https://produktfinder.teckpro.de", "_blank", "noopener,noreferrer")
        } else {
            navigate("/live-cockpit")
        }
    }

    return Object.freeze({
        NAVIGATE_LEBENSMEILENSTEINE: navGen("/lifestones"),
        NAVIGATE_ZUKUNFTSPLANUNG: navGen("/zukunftsplanung"),
        NAVIGATE_GESAMTANALYSE: navGen("/gesamtanalyse"),
        NAVIGATE_QS_TOOL: navGen("/qs-tool"),
        NAVIGATE_VERSORGUNGSUEBERSICHT: navGen("/versorgunsguebersicht"),
        NAVIGATE_RUHESTAND: navGen("/ruhestand"),
        NAVIGATE_BACK: navGen(-1),
        NAVIGATE_TARIFERHOEHUNG: navGen("/tariferhoehung"),
        NAV_BEDARFSCHECK: navGen("/bedarfscheck"),
        NAVIGATE_LIVE_COCKPIT: navGen("/live-cockpit"),
        NAVIGATE_RUHESTAND_ABSCHLUSS: navGen("/ruhestandabschluss"),
        NAVIGATE_HINTERBLIEBENE_SCHLIESSEN: navGen("/hinterbliebenen-schliessen"),
        NAVIGATE_HINTERBLIEBENE: navGen("/hinterbliebenen"),
        NAVIGATE_EKS_SCHLIESSEN: navGen("/einkommensschutzschliessen"),
        NAVIGATE_EKS: navGen("/einkommensschutz"),
        NAVIGATE: navigateAction,
        NAVIGATE_DEVK: navigateDevk,
        NAVIGATE_ANGEBOT: navigateAngebot,
        NAVIGATE_THEMENFELD: (value) => {
            if(value) {
                updateData(value, "/appstate/selectedThemenfeld")
                updateData(true, "/pageState/absicherungsprofilDialogOpen")
            } else {
                updateData({}, "/appstate/selectedThemenfeld")
            }
            navigate("/absicherungsprofil")
        }
    })
}
